<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 13 8"
>
  <path
    [attr.stroke]="color"
    d="M1 1L6.5 6L12 1"
    stroke-width="2"
  />
</svg>
